/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_B3_TitleInputs */

const en_simple_oto_b3_title = /** @type {(inputs: Simple_Oto_B3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Try it on your phone`)
};

const id_simple_oto_b3_title = /** @type {(inputs: Simple_Oto_B3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Coba di HP`)
};

/**
* | output |
* | --- |
* | "3. Try it on your phone" |
*
* @param {Simple_Oto_B3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_b3_title = /** @type {((inputs?: Simple_Oto_B3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_B3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_b3_title(inputs)
	return en_simple_oto_b3_title(inputs)
});